<template>
	<div class="master-facility-inner-wrapper">
		<ja-dropdown
			v-model="facilityFilteringOptionIndex"
			class="facilities-dropdown"
			:options="facilities"
			name="facility"
			size="slim"
			@input="updateTemplate"
		></ja-dropdown>
	</div>
</template>

<script>
import Dropdown from '@/components/ui/form/Dropdown';
import FacilitiesService from '@/services/cms/FacilityService';
import UserData from '@/mixins/UserData';
import CryptoJS from 'crypto-js';

export default {
	components: {
		jaDropdown: Dropdown
	},
	mixins: [UserData],
	props: {},
	data() {
		return {
			facilityFilteringOptionIndex: 0,
			studentsTabname: 'Students',
			facilities: []
		};
	},
	computed: {
		selectedFacility() {
			if (this.facilities.length !== 0) {
				return this.facilities[this.facilityFilteringOptionIndex];
			}
			return null;
		}
	},
	watch: {
		facilities() {
			if (this.$store.getters.selectedFacility == null) {
				this.updateTemplate();
			} else {
				const currentFacility = this.facilities.filter(
					x => x.facility_ID == this.$store.getters.selectedFacility.facility_ID
				);
				const currentIndex = this.facilities.indexOf(currentFacility[0]);
				if (currentIndex >= 0) {
					this.facilityFilteringOptionIndex = currentIndex;
				} else {
					this.updateTemplate();
				}
			}
		}
	},
	created() {
		const key = CryptoJS.SHA256(this.userData.email).toString();
		const myFacility = localStorage.getItem(key)
			? JSON.parse(localStorage.getItem(key))
			: null;

		this.$store.dispatch('updateSelectedFacility', myFacility);
		this.getFacilities();
	},
	methods: {
		updateTemplate() {
			this.$store.dispatch('updateSelectedFacility', this.selectedFacility);
		},
		async getFacilities() {
			const facilities = await FacilitiesService.getAllByUser();
			this.facilities = facilities.sort((a, b) =>
				a.name < b.name ? -1 : a.name > b.name ? 1 : 0
			);
		}
	}
};
</script>
<style lang="scss" scoped>
.master-facility-inner-wrapper {
	display: inline-block;
	padding: 8px 0px 8px 0px;
	width: 100%;
	position: relative;
	font-family: 'RobotoRegular';
	font-size: 15px;
	letter-spacing: 0.5px;
	background-color: $container-bgcolor;
	color: $questionnaire-color;
	//border: 1px solid $container-border;
	border-radius: 8px;
	//box-shadow: 0 15px 30px 0 rgba(0, 76, 208, 0.24);

	@media (min-width: $breakpoint-mid) {
		font-size: 18px;
		line-height: 26px;
	}

	.dropdown-wrapper {
		.dropdown {
			input {
				border: none;
			}
		}
	}

	.dropdown-component {
		display: block;
		align-items: center;
		width: 100%;

		label {
			min-width: 60px;
			min-width: fit-content;
		}

		::v-deep.dropdown-wrapper {
			width: inherit !important;

			::v-deep .dropdown {
				width: auto;
			}
		}
	}
}
</style>
